import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SurveyUserPermissionModalComponent} from "./survey-user-permission-modal.component";
import {
  BannerModule,
  ButtonModule,
  CardsModule,
  AvatarModule,
  CheckboxModule,
  DropdownModule,
  InputsModule,
  TagsModule
} from "@xref/xref-lib";
import {PaginationModule} from "ngx-bootstrap/pagination";
import {AvatarIconModule} from "../avatar-icon/avatar-icon.module";
import {SearchCoreModule} from "../search-core/search-core.module";
import {AppPaginationModule} from "../pagination/pagination.module";
import {LoaderModule} from "../loader/loader.module";
import {FilterUsersModule} from "../filter-users/filter-users.module";
import {SortV2Module} from "../sort-v2/sort-v2.module";
import {FormsModule} from "@angular/forms";
import { TooltipModule as XrefTooltipModule } from '@xref/xref-lib';
import {FilterPopupModule} from "../filter-popup/filter-popup.module";

@NgModule({
  declarations: [SurveyUserPermissionModalComponent],
  imports: [
    CommonModule,
    ButtonModule,
    PaginationModule.forRoot(),
    DropdownModule,
    InputsModule,
    CardsModule,
    AvatarModule,
    CheckboxModule,
    AvatarIconModule,
    XrefTooltipModule,
    SearchCoreModule,
    AppPaginationModule,
    LoaderModule,
    FilterUsersModule,
    BannerModule,
    SortV2Module,
    TagsModule,
    FormsModule,
    FilterPopupModule

  ],
  exports: [SurveyUserPermissionModalComponent]
})
export class SurveyUserPermissionModalModule {
}
